module.exports = __webpack_public_path__ + "assets/ns-icon-query.6c099116.svg";